/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DOM from './users';
import UsersTab from './tabs/UsersTab';
import * as AssetActions from '../../core/asset/assetActions';
import * as UserActions from '../../core/user/userActions';
import * as FiltersActions from '../../core/filters/filtersActions';

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userCreateModalOpen: false,
            searchParams: props.userTabFilters,
            orderParams: {},
            currentTabKey: '1',
            data: [],
        };
        this.view = DOM;
        this.usersTabContent = UsersTab;
    }

    componentDidMount() {
        const { actions, orderParams, } = this.props;
        const { searchParams } = this.state;

        actions.getUsersPageRequest({ page: 1, searchParams, ...orderParams });
        actions.clearUserViewFormRequest();
    }

    filterUsers(newFilters) {
        const { actions, orderParams } = this.props;

        actions.getUsersPageRequest({ page: 1, searchParams: newFilters, orderParams });
        actions.setUserTabFilters(newFilters);
        this.setState({ searchParams: newFilters });
    }

    removeUser(user_id) {
        const { actions } = this.props;

        actions.deleteUserRequest({ user_id });
    }

    paginationChange(page) {
        const {
            actions, orderParams,
        } = this.props;
        const { searchParams } = this.state;

        if (page !== page.pagination.currentPage) {
            actions.getUsersPageRequest({ page: 1, searchParams, orderParams });
        }
    }

    render() {
        return this.view();
    }
}

Users.propTypes = {
    actions: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
    usersPagination: PropTypes.object.isRequired,
    usersIsFetching: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        users: state.user.users,
        usersPagination: state.user.usersPagination,
        usersIsFetching: state.user.isFetching,
        user: state.user,
        orderParams: state.user.userOrderParams,
        userTabFilters: state.filters.userTabFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...AssetActions,
                ...UserActions,
                ...FiltersActions,
            },
            dispatch,
        ),
    };
}
export const UsersTest = Users;
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Users);
